import { Model } from '../parents/model';
import { CustomerModel } from './customer.model';

export class MeModel extends Model {
  static ATTR_USER = 'user';
  static ATTR_PERMISSIONS = 'permissions';

  static EMBED_USER_ROLES = 'user_roles';


  get user() {
    return new CustomerModel(this.attributes[MeModel.ATTR_USER]);
  }
  get permissions() {
    return this.attributes[MeModel.ATTR_PERMISSIONS];
  }

  get userRoles() {
    return this.embeds[MeModel.EMBED_USER_ROLES];
  }
}
